/* scroll animations plugin */
(function($) {
    $.fn.animateIn = function(options) {
        return this.each(function() {
            const settings = $.extend(
                {
                    //default settings
                    offset: 0,
                    modifier: '__in'
                },
                options
            );

            const item = $(this);
            const itemOffsetTop = $(this).offset().top;
            const triggerVal = itemOffsetTop + settings.offset;

            function animateBlock(scrollTop) {
                // if element is already in view or check if it comes into view
                if (
                    scrollTop + $(window).outerHeight() >= triggerVal ||
                    $(window).outerHeight() >= triggerVal
                ) {
                    item.addClass(settings.modifier);
                }
            }

            $(window).scroll(function() {
                const scrollTop = $(window).scrollTop();
                animateBlock(scrollTop);
            });
            $(window).scroll();
        });
    };
})($);
